import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IEmpDlts } from "../../models/EmpDlts";

import { Filter, IEmptyFilterEmp, IFilterEmpDlts } from "./Filter";
import { IPermissionProps } from "../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";




export interface IModel {
    open: boolean,
    singleData: IEmpDlts
}
interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEmpDlts>, loading: boolean });
    // const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [filters, setFilters] = useState<IFilterEmpDlts>(IEmptyFilterEmp);


    const dt = useRef<any>(null);
    // const [lazyParams, setLazyParams] = useState<ILazyParams>({
    //     first: 0,
    //     rows: 25,
    //     page: 1,
    //     sortField: '',
    //     sortOrder: -1
    // });
    const [filter, setFilter] = useState(false);
    const hideFilterDialog = () => {
        setFilter(false);
    };

    useEffect(() => {
        // getTableDataCount();
        // loadTableData();
    }, [globalFilter, filters, props.reload]);



    const exportCSV = () => {
        dt.current.exportCSV();
    };

    // const getTableDataCount = async () => {
    //     const response = await Fetch("ShowPurchaseOrder/count", "GET", null, `filter=${globalFilter}`, props.toast);
    //     if (response) {
    //         const count: number = parseInt(await response.text(), 10);
    //         // setTotalRecords(count);
    //     }
    // }

    // const loadTableData = async () => {
    //     setTableData({ tableData: tableData.tableData, loading: true });
    //     const response = await Fetch("ShowPurchaseOrder", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
    //     if (response) {
    //         const data: Array<IPurchaseOrder> = await response.json();
    //         setTableData({ tableData: data, loading: false });
    //     }
    // }





    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0"> Employee Details </h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );



    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterEmpDlts) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop:"5px" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="id"

                emptyMessage="No Company found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="emp_Code" header="Emp Code  " />
                <Column field="emp_Name" header="Emp  Name" />
                <Column field="team_lead" header="Team Lead " />
                <Column field="mobile" header="Mobile " />

                <Column field="hangout" header="Hangout  " />
                <Column field="branch" header="Branch  " />




            </DataTable>

            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setFilters={(filters: string | null) => setFilters(filters)} /> */}

        </>
    );
}
